import { TableRow, TableCell, Flex, View, Text } from "@aws-amplify/ui-react";
import * as React from "react";

import { Question } from "../../../API";
import {
  ResultsTableAnswerButton,
  useAnswerResultsAnalytics,
} from "../../class";
import { GameData } from "../../game/Types/GameTypes";

export interface IResultsTableRowProps {
  playerName: string;
  questions: (Question | null | undefined)[] | undefined;
  gameData: GameData;
  teamNumber: number;
}

export function ResultsTableRow(props: IResultsTableRowProps) {
  const { playerName, gameData, questions, teamNumber } = props;

  const { score, numCorrect, total } = useAnswerResultsAnalytics(
    gameData.answerResults
  );

  const color = React.useMemo(() => {
    if (score < 50) return "var(--amplify-colors-red-60)";
    if (score < 80) return "var(--amplify-colors-orange-60)";
    return "var(--amplify-colors-green-80)";
  }, []);

  return (
    <TableRow>
      <TableCell as="td" textAlign={"center"}>
        <Flex
          direction={"column"}
          justifyContent={"center"}
          borderRadius={"xxl"}
          color="white"
          id="raised-item"
          backgroundColor={color}
          padding={"xs"}
          grow={1}
          fontWeight={"semibold"}
        >
          <Text isTruncated color={"inherit"}>
            {playerName}
          </Text>
        </Flex>
      </TableCell>
      <TableCell as="td" textAlign={"center"}>
        {teamNumber}
      </TableCell>
      <TableCell as="td" textAlign={"center"}>
        {numCorrect}/{total}
      </TableCell>
      <TableCell as="td" width={"40px"}>
        <Flex justifyContent={"start"} paddingLeft={"small"}>
          {gameData?.answerResults.map((answerResult, i) => (
            <View key={i}>
              <ResultsTableAnswerButton
                answerResult={answerResult}
                question={questions?.[i]}
              />
            </View>
          ))}
        </Flex>
      </TableCell>
    </TableRow>
  );
}
